if (!customElements.get("cart-timer")) {
    class e extends HTMLElement {
        constructor() {
            super();
            var n = this,
                e = parseInt(this.dataset.time);
            let t, o, a = !1;

            if (localStorage.getItem("cartTimerEnd")) {
                t = localStorage.getItem("cartTimerActual");
                o = localStorage.getItem("cartTimerEnd");
            } else {
                t = (new Date).getTime();
                o = new Date(t + 6e4 * e).getTime();
                localStorage.setItem("cartTimerActual", t);
                localStorage.setItem("cartTimerEnd", o);
            }

            e = () => {
                t = (new Date).getTime();
                localStorage.setItem("cartTimerActual", t);
                var r = o - t;

                if (r < 0) {
                    n.innerHTML = "<span>" + Shopify.translation.timer_ended + "</span>";
                    if (r < -864e5) {
                        localStorage.removeItem("cartTimerInitial");
                        localStorage.removeItem("cartTimerEnd");
                    }
                    a && clearInterval(i);
                } else {
                    let e = Math.floor(r % 36e5 / 6e4),
                        t = Math.floor(r % 6e4 / 1e3);

                    e <= 9 ? e = `0${e}` : e;
                    t <= 9 ? t = `0${t}` : t;

                    r = 0 < e ? Shopify.translation.date.m : Shopify.translation.date.minute;
                    n.querySelector(".dynamic").textContent = e + ":" + t + " " + r;
                }
            };

            e();
            a = !0;
            const i = setInterval(e, 1e3);
        }
    }
    customElements.define("cart-timer", e);
}

if (!customElements.get("cart-js")) {
    class e extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            var t = this;
            this.cartFooter = this.querySelector("[data-sticky-mobile]");

            if (this.classList.contains("cart") && this.cartFooter && "true" == this.cartFooter.getAttribute("data-sticky-mobile")) {
                document.documentElement.clientWidth < 779 ? t.setPosition() : t.unsetPosition();
                window.on("resize", theme.utils.debounce(300, function () {
                    document.documentElement.clientWidth < 779 ? t.setPosition() : t.unsetPosition();
                }));
            } else {
                t.unsetPosition();
            }

            if ("true" == this.getAttribute("data-keep-on-page")) {
                this.keepOnPage();
            }

            this.initListeners();

            document.addEventListener("updateCart", function (e) {
                t.getCart();
            });
        }

        initListeners() {
            var t = this;
            window.AddCount = 0;

            this.querySelectorAll(".quantity__button").forEach(e => {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    t.updateItem(this.href);
                });
            });

            this.querySelectorAll("input.quantity__input").forEach(e => {
                e.addEventListener("change", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    t.updateInputItem(this);
                });
            });

            this.querySelectorAll("select.cart__selector-variant").forEach(e => {
                e.addEventListener("change", function (e) {
                    e.preventDefault();
                    t.updateVariant(this.value, this.dataset.actual, this.dataset.quantity);
                });
            });
        }

        removeListeners() {
            document.removeEventListener("updateCart", function () {
                self.getCart();
            });

            this.querySelectorAll(".quantity__button").forEach(e => {
                e.removeEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.updateItem(this.href);
                });
            });

            this.querySelectorAll("input.quantity__input").forEach(e => {
                e.removeEventListener("change", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.updateInputItem(this);
                });
            });

            this.querySelectorAll("select.cart__selector-variant").forEach(e => {
                e.removeEventListener("change", function (e) {
                    e.preventDefault();
                    self.updateVariant(this.value, this.dataset.actual, this.dataset.quantity);
                });
            });
        }

        updateItem(e) {
            this.innerHTML += Shopify.theme_settings.loader;
            this.classList.add("loading");
            window.ajaxURL(e).then(function () {
                document.dispatchEvent(new CustomEvent("updateCart"));
            });
        }

        updateInputItem(e) {
            this.innerHTML += Shopify.theme_settings.loader;
            this.classList.add("loading");
            document.querySelectorAll(".cart-bubble").forEach(e => {
                e.innerHTML = Shopify.theme_settings.loader;
            });
            window.ajaxURL(theme.routes.cart_change_url + "?quantity=" + e.value + "&id=" + e.dataset.lineId)
                .then(function () {
                    document.dispatchEvent(new CustomEvent("updateCart"));
                });
        }

        updateVariant(e, t, r) {
            this.innerHTML += Shopify.theme_settings.loader;
            this.classList.add("loading");
            document.querySelectorAll(".cart-bubble").forEach(e => {
                e.innerHTML = Shopify.theme_settings.loader;
            });

            window.ajaxURL(theme.routes.cart_change_url + "?quantity=" + r + "&id=" + t)
                .then(function () {
                    window.ajaxURL(theme.routes.cart_add_url + "?quantity=1&id=" + e)
                        .then(function () {
                            document.dispatchEvent(new CustomEvent("updateCart"));
                        })
                        .catch(e => console.error("Error:", e));
                })
                .catch(e => console.error("Error:", e));
        }

        getCart() {
            const t = this;
            window.ajaxURL(theme.routes.cart_url).then(function (e) {
                t.renderCart(e);
            });
        }

        renderCart(e) {
            var t = this;
            let r = (new DOMParser).parseFromString(e, "text/html"),
                n, o;

            const isCartPage = window.location.pathname === '/cart';

            o = t.classList.contains("minicart-container") && !t.closest(".cart-section")
                ? (n = ".minicart-container", !0)
                : !(n = ".cart-section");

            document.querySelectorAll(".cart-bubble").forEach(e => {
                const bubbleSource = r.querySelector(".cart-bubble");
                if (bubbleSource && 0 < bubbleSource.innerHTML) {
                    e.classList.remove("hide");
                    e.innerHTML = bubbleSource.innerHTML;
                } else {
                    e.classList.add("hide");
                }
            });

            if (r.querySelector(n + " .cart__empty") && !t.querySelector(".cart__empty")) {
                t.querySelectorAll(':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block').forEach(e => {
                    e.classList.add("hide");
                });

                if (localStorage.getItem("cartTimerInitial")) {
                    localStorage.removeItem("cartTimerInitial");
                    localStorage.removeItem("cartTimerEnd");
                }

                const targetCart = t.querySelector(n + " .cart");
                const sourceCart = r.querySelector(n + " .cart");
                if (o && targetCart && sourceCart) {
                    targetCart.innerHTML = sourceCart.innerHTML;
                } else {
                    t.innerHTML = sourceCart ? sourceCart.innerHTML : e;
                }
            } else {
                if (o && !isCartPage) {
                    const targetBlocks = t.querySelector(n + " .minicart-blocks");
                    const sourceBlocks = r.querySelector(n + " .minicart-blocks");
                    const targetContent = t.querySelector(n + " .cart__content");
                    const sourceContent = r.querySelector(n + " .cart__content");
                    const targetFooter = t.querySelector(n + " .minicart-footer");
                    const sourceFooter = r.querySelector(n + " .minicart-footer");

                    if (t.querySelector(".cart__empty") && targetBlocks && sourceBlocks) {
                        targetBlocks.innerHTML = sourceBlocks.innerHTML;
                    } else if (targetContent && sourceContent) {
                        targetContent.innerHTML = sourceContent.innerHTML;
                    }
                    if (targetFooter && sourceFooter) targetFooter.innerHTML = sourceFooter.innerHTML;
                } else {
                    const targetWrapper = t.querySelector(n + " .cart__wrapper");
                    const sourceWrapper = r.querySelector(n + " .cart__wrapper");
                    const targetContent = t.querySelector(n + " .cart__content");
                    const sourceContent = r.querySelector(n + " .cart__content");
                    const targetFooterNotAdded = t.querySelector(n + " .cart__footer:not(.added)");
                    const sourceFooterNotAdded = r.querySelector(n + " .cart__footer:not(.added)");

                    if (t.querySelector(".cart__empty") && targetWrapper && sourceWrapper) {
                        targetWrapper.innerHTML = sourceWrapper.innerHTML;
                    } else {
                        if (targetContent && sourceContent) targetContent.innerHTML = sourceContent.innerHTML;
                        if (targetFooterNotAdded && sourceFooterNotAdded) targetFooterNotAdded.innerHTML = sourceFooterNotAdded.innerHTML;
                    }
                }

                t.querySelectorAll(':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block').forEach(e => {
                    e.classList.remove("hide");
                });
            }

            if (o && !isCartPage) {
                const miniCart = this.closest("mini-cart");
                if (miniCart) {
                    miniCart.bindEvents();
                    if (document.querySelectorAll("mini-cart").length > 0 &&
                        ("once" == Shopify.theme_settings.atc_action || "always" == Shopify.theme_settings.atc_action)) {
                        const e = document.querySelector(".menu-icons mini-cart");
                        if (e) {
                            document.body.classList.remove("scroll_up");
                            document.body.classList.remove("scroll_down");
                            e.open();
                        }
                    }
                }
            } else {
                t.querySelector("product-form") && t.querySelectorAll("product-form").forEach(e => {
                    const t = e.querySelector("form");
                    if (t) t.addEventListener("submit", e.onSubmitHandler.bind(e));
                });
            }

            t.initListeners();
            t.querySelectorAll(".loader").forEach(e => e.remove());
            t.classList.remove("loading");
            t.querySelectorAll("img, svg").forEach(e => {
                if (theme.utils && theme.utils.lazyBackgroundObserver) {
                    theme.utils.lazyBackgroundObserver.observe(e);
                }
            });
            document.dispatchEvent(new CustomEvent("cartRendered"));
        }

        setPosition() {
            if (this.cartFooter) {
                this.cartFooter.closest(".cart").classList.add("added");
                document.querySelector("footer").style.marginBottom = this.cartFooter.offsetHeight + "px";
            }
        }

        unsetPosition() {
            if (document.querySelector("footer")) {
                document.querySelector("footer").style.marginBottom = "";
            }
            if (this.cartFooter) {
                this.cartFooter.closest(".cart").classList.remove("added");
            }
        }

        keepOnPage() {
            var t = document.title,
                r = Shopify.translation.keep_on_page;

            document.addEventListener("visibilitychange", function (e) {
                !document.hidden ? document.title = t : setTimeout(function () {
                    document.title = r;
                }, 300);
            });
        }
    }

    customElements.define("cart-js", e);
}